// extracted by mini-css-extract-plugin
export default {"info-icon":"OtherSectionHeadings_info-icon__Hf6BT","content-divider":"OtherSectionHeadings_content-divider__Q1kJC"};